import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/lib/supabase/client';

export function useCurrentUserImage() {
  const { user } = useAuth()

  const { data: profileImage = null } = useQuery({
    queryKey: ['current-user-image', user?.id],
    queryFn: async (): Promise<string | null> => {
      if (!user) return null

      try {
        const { data: profile, error } = await supabase
          .from('profiles')
          .select('avatar_url')
          .eq('id', user.id)
          .maybeSingle()

        if (error && error.code !== 'PGRST116') {
          console.warn('Erreur lors du chargement du profil:', error)
          return user.user_metadata?.picture || null
        }

        return profile?.avatar_url || user.user_metadata?.picture || null
      } catch (error) {
        console.warn('Erreur inattendue lors du chargement de l\'avatar:', error)
        return user.user_metadata?.picture || null
      }
    },
    enabled: !!user,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  })

  return profileImage
}
